export default {
    methods : {
        registerCompareClickCallback(columns, callback) {
            columns.map(function(column) {
                column.meta        = column.meta        || {};
                column.meta.events = column.meta.events || {};
                column.meta.events.onCompareClick = function(event) { 
                    event.stopPropagation(); 
                    if( typeof callback === 'function' ) {
                        callback(this);
                    }                                               
                }  
            });
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/common/table_v3/mixin/comparable.mixin.js